document.addEventListener("DOMContentLoaded", function () {
    let priceSlider = document.getElementById('price-slider');
    let buyingPriceInput = document.getElementById('buyingPrice');
    let initialSlider = document.getElementById('initial-slider');
    let percentageNode = document.getElementById('percentage');

    let loanTotalLabel = document.getElementById("loan-total");
    let financedAmountLabel = document.getElementById('financed-amount');
    let interestAmountLabel = document.getElementById("interest-amount");
    let givenAmountInput = document.getElementById("givenAmount");
    let montlyPaymentLabel = document.getElementById("montly-payment");
    let transactionTotalLabel = document.getElementById("trasaction-total");
    
    let monthsInput = document.getElementById("months");
    let taxRateInput = document.getElementById('taxRate');
    let monthsSlider = document.getElementById('months-slider');

    let simulatorSection = document.getElementById('simulator-section');
    let productPriceFromShopify = simulatorSection ? simulatorSection.getAttribute('data-product-price') : null;
    let productPrice = productPriceFromShopify ? 
        parseInt(productPriceFromShopify.slice(0, -2)) : 
        100000;
    let financedAmount = 0;
    let initialPercentage = 0;
    let interestAmount = 0;
    let loanTotalAmount = 0;
    let montlyPaymentAmount = 0;
    let transactionTotalAmount = 0;

    let evangelizadoresAlert = document.getElementById('evangelizadores-alert');
    
    noUiSlider.create(priceSlider, {
        start: [productPrice],
        step: 100,
        animate: false,
        range: {
            'min': [productPrice],
            'max': [productPrice]
        },
        connect: 'lower'
    });
    
    priceSlider.setAttribute('disabled', true);
    
    noUiSlider.create(initialSlider, {
        start: [productPrice * 60 / 100],
        step: 100,
        animationDuration: 1600,
        animate: true,
        range: {
            'min': [productPrice * 40 / 100],
            'max': [productPrice * 90 / 100]
        },
        connect: 'lower'
    });

    noUiSlider.create(monthsSlider, {
        start: [6],
        step: 1,
        animate: true,
        animationDuration: 1600,
        range: {
            'min': [3],
            'max': [12]
        },
        connect: 'lower'
    });

    const formater = new Intl.NumberFormat('de-DE', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
    });

    function parseFormattedValue(formattedValue) {
        if (!formattedValue) return 0;
        return parseFloat(formattedValue.toString()
            .replace(/\./g, '')
            .replace(',', '.')
        ) || 0;
    }

    initialSlider.noUiSlider.on('update', function (values, handle, unencoded, isTap, positions) {
        let currentInitialValue = parseInt(values[0]);
        
        initialPercentage = Math.round((currentInitialValue / productPrice) * 100);
        percentageNode.innerHTML = initialPercentage + '%';
        
        givenAmountInput.value = formater.format(currentInitialValue);
        
        financedAmount = productPrice - currentInitialValue;
        
        updateAmounts();
        updateLabels();
    });

    function updateLabels() {
        financedAmountLabel.innerHTML = formater.format(financedAmount);
        interestAmountLabel.innerHTML = formater.format(interestAmount);
        loanTotalLabel.innerHTML = formater.format(loanTotalAmount);
        transactionTotalLabel.innerHTML = formater.format(transactionTotalAmount);
        montlyPaymentLabel.innerHTML = formater.format(montlyPaymentAmount);
    }

    function updateAmounts() {
        let interestRate = calculateInterestRate(initialPercentage, monthsInput.value);
        
        taxRateInput.value = interestRate;
        
        interestAmount = financedAmount * interestRate / 100;
        
        loanTotalAmount = financedAmount + interestAmount;
        
        transactionTotalAmount = parseFormattedValue(givenAmountInput.value) + loanTotalAmount;
        
        montlyPaymentAmount = loanTotalAmount / monthsInput.value;
        
        showEvangelizadoresAlert();
    }

    function showEvangelizadoresAlert() {
        if (evangelizadoresAlert) {
            if (initialPercentage <= 59) {
                evangelizadoresAlert.classList.add('show');
            } else {
                evangelizadoresAlert.classList.remove('show');
            }
        }
    }

    givenAmountInput.addEventListener('change', function () {
        let numericValue = parseFormattedValue(this.value);
        
        initialSlider.noUiSlider.set(numericValue);
        
        this.value = formater.format(numericValue);
        
        initialPercentage = Math.round((numericValue / productPrice) * 100);
        percentageNode.innerHTML = initialPercentage + '%';
        financedAmount = productPrice - numericValue;
        
        updateAmounts();
        updateLabels();
    });

    monthsSlider.noUiSlider.on('update', function (values, handle) {
        monthsInput.value = parseInt(values[handle]);
        updateAmounts();
        updateLabels();
    });

    monthsInput.addEventListener('change', function () {
        monthsSlider.noUiSlider.set(this.value);
        updateAmounts();
        updateLabels();
    });

    function initialize() {
        buyingPriceInput.value = formater.format(productPrice);
        
        let initialValue = Math.round(productPrice * 60 / 100);
        givenAmountInput.value = formater.format(initialValue);
        initialPercentage = Math.round((initialValue / productPrice) * 100);
        percentageNode.innerHTML = initialPercentage + '%';
        financedAmount = productPrice - initialValue;
        
        updateAmounts();
        updateLabels();
    }

    initialize();
    
    showEvangelizadoresAlert();
});

function calculateInterestRate(percentage, months) {
    months = parseInt(months);
    
    let baseRate = 8;
    
    if (months <= 6) {
        return baseRate;
    }
    
    let additionalMonths = months - 6;
    let additionalPeriods = Math.ceil(additionalMonths / 3);
    let additionalRate = additionalPeriods * 3;
    
    let finalRate = baseRate + additionalRate;
 
    return finalRate;
} 